import getEnvEndpoints from "./endpoints";

const endpoints = getEnvEndpoints();

export const persistUser = data => {
  sessionStorage.setItem(endpoints.ls_name, JSON.stringify(data));
};

export const getUserData = () => {
  return JSON.parse(sessionStorage.getItem(endpoints.ls_name));
};

export const getUserId = () => {
    let userId = getUserData()?.id;
    return isNaN(userId) ? 0 : parseInt(userId);
};

export const clearUserData = () => {
  sessionStorage.removeItem(endpoints.ls_name);
  sessionStorage.clear();
};

export const getToken = () => {
    const userData = getUserData();

    if (userData) {
        return userData.access_token;
    }

    return null;
};

export const hasUserData = () => {
  return !!sessionStorage.getItem(endpoints.ls_name);
};

export const isTokenExpired = () => {
  const token = getUserData();
  if (!token || !token.exp_date) {
    return true
  }

  const now = new Date();
  const tokenExpirationDate = new Date(token.exp_date);

  return now > tokenExpirationDate;
};

export const setShareDeeplink = (shareDeeplink, shareDeeplinkPath) => {
  sessionStorage.setItem(shareDeeplink, shareDeeplinkPath);
};

export const getShareDeeplink = (shareDeeplink) => {
  return sessionStorage.getItem(shareDeeplink) || null;
};

export const clearShareDeeplink = (shareDeeplink) => {
  sessionStorage.removeItem(shareDeeplink);
};
